import { call, put, takeLatest } from "redux-saga/effects"
import { getDimensionsDataFailed, getDimensionsDataSuccess } from "./actions"
import { GET_DIMENSIONS_DATA_WATCHER } from "./constants"
import { getDimensionsApi } from "../../../utils/routes/routes-report"

export function* getDimensionsDataSaga(action) {
  try {
    const dataStatus = action.payload
    const data = yield call(getDimensionsApi, dataStatus.params)
    yield put(getDimensionsDataSuccess(data))
  } catch (e) {
    yield put(getDimensionsDataFailed())
  }
}

export default function* climateMeasurementV2Saga() {
  yield takeLatest(GET_DIMENSIONS_DATA_WATCHER, getDimensionsDataSaga)
}
